import { ModuleType } from '../../../../types/modules';

export const ModuleTypeToStatNameMap = {
  [ModuleType.WATCHERS]: 'watchers',
  [ModuleType.WATCHING]: 'watching',
  [ModuleType.BADGES_ACTIVITY]: 'badgesReceived',
  [ModuleType.GROUPS_ADMIN]: 'groupsAdmin',
  [ModuleType.GROUPS_MEMBER]: 'groupsMember',
  [ModuleType.MY_COMMENTS]: 'commentsMade',
};
